import * as types from '../mutation-types'
import Storage from '@/services/storage'
import { router } from '@/router'

// 该模块的初始状态
const state = {
  pageOpenedList: [{
    title: '首页',
    path: '',
    name: 'home_index'
  }],
  currentPageName: '',
  currentPath: [{
    title: '首页',
    path: '',
    name: 'home_index'
  }],
  cachePage: JSON.parse(Storage.getItem('cachePage', []))
}

// 相关的 mutations
const mutations = {
  [types.CLOSE_PAGE] (state, name) {
    state.cachePage.forEach((item, index) => {
      if (item === name) {
        state.cachePage.splice(index, 1)
      }
    })
  },
  [types.SET_CURRENT_PATH] (state, pathArray) {
    state.currentPath = pathArray
  },
  [types.SET_CURRENT_PAGE_NAME] (state, name) {
    state.currentPageName = name
  },
  [types.REMOVE_TAG] (state, name) {
    state.pageOpenedList.map((item, index) => {
      if (item.name === name) {
        state.pageOpenedList.splice(index, 1)
      }
    })
  },
  [types.CLEAR_ALL_TAGS] (state) {
    state.pageOpenedList.splice(1)
    router.push({
      name: 'home_index'
    })
    state.cachePage.length = 0
    Storage.setItem('pageOpenedList', JSON.stringify(state.pageOpenedList))
  },
  [types.CLEAR_OTHER_TAGS] (state, vm) {
    let currentName = vm.$route.name
    let currentIndex = 0
    state.pageOpenedList.forEach((item, index) => {
      if (item.name === currentName) {
        currentIndex = index
      }
    })
    if (currentIndex === 0) {
      state.pageOpenedList.splice(1)
    } else {
      state.pageOpenedList.splice(currentIndex + 1)
      state.pageOpenedList.splice(1, currentIndex - 1)
    }
    let newCachepage = state.cachePage.filter(item => {
      return item === currentName
    })
    state.cachePage = newCachepage
    Storage.setItem('pageOpenedList', JSON.stringify(state.pageOpenedList))
  }
}

export default {
  state,
  mutations
}
